import React from 'react';
import { BookOpen, Clock, Check, Star, Download, ShieldCheck, ArrowRight } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { UrgencyBar } from '../components/UrgencyBar';
export function HistoriaLandingPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#F4E8D8] font-sans text-[#2D241E] overflow-x-hidden selection:bg-[#7C2D2D] selection:text-[#F4E8D8]" data-id="element-64">
      <PurchaseNotification data-id="element-65" />
      <UrgencyBar data-id="element-66" />

      {/* Navigation Bar */}
      <nav className="bg-[#2D241E] text-[#F4E8D8] py-3 px-4 sticky top-0 z-40 shadow-md border-b-4 border-[#7C2D2D]" data-id="element-67">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-68">
          <div className="font-serif font-bold text-xl tracking-wider flex items-center gap-2" data-id="element-69">
            <BookOpen className="w-5 h-5" data-id="element-70" />
            <span data-id="element-71">HISTORIA DOCENTE</span>
          </div>
          <button onClick={scrollToPurchase} className="bg-[#7C2D2D] hover:bg-[#963E3E] text-[#F4E8D8] px-4 py-1.5 rounded-sm font-serif font-bold text-sm transition-colors border border-[#F4E8D8]/30" data-id="element-72">
            DESCARGAR PACK
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-73">
        <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')] pointer-events-none" data-id="element-74"></div>

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-75">
          <div className="inline-block border-b-2 border-[#7C2D2D] pb-1 mb-6" data-id="element-76">
            <span className="font-serif text-[#7C2D2D] font-bold tracking-widest uppercase text-sm" data-id="element-77">
              Para docentes de nivel secundario
            </span>
          </div>

          <h1 className="font-serif text-4xl md:text-6xl font-bold text-[#2D241E] mb-6 leading-tight" data-id="element-78">
            Enseñar Historia no debería <br data-id="element-79" />
            <span className="text-[#7C2D2D] italic" data-id="element-80">dejarte sin energía</span>
          </h1>

          <p className="font-sans text-lg md:text-xl text-[#5D4037] max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-81">
            Si sos docente de Historia de nivel secundario, esto no es una
            teoría pedagógica. Es tu rutina.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-16" data-id="element-82">
            <div className="w-full max-w-md transform hover:scale-105 transition-transform duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/5T675VarCUtHqFeg6PgLFE/HISTORIA_I_Historia_Antigua_y_Origenes_de_la_Humanidad_(4).png" alt="Pack Historia Integral" className="w-full drop-shadow-2xl rounded-sm border-4 border-[#FFF8E7]" data-id="element-84" />
            </div>
          </div>

          <button onClick={scrollToPurchase} className="group bg-[#7C2D2D] text-[#F4E8D8] text-xl md:text-2xl px-8 py-4 rounded-sm font-serif font-bold shadow-lg hover:bg-[#5D2020] hover:shadow-xl transition-all border-2 border-[#8B4513] flex items-center gap-3 mx-auto" data-id="element-85">
            <span data-id="element-86">QUIERO RECUPERAR MI TIEMPO</span>
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-87" />
          </button>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-20 px-4 bg-[#FFF8E7] border-y border-[#8B4513]/20 relative" data-id="element-88">
        <div className="max-w-3xl mx-auto" data-id="element-89">
          <div className="prose prose-lg prose-stone mx-auto font-sans text-[#5D4037]" data-id="element-90">
            <p className="font-serif text-2xl text-[#2D241E] font-bold mb-6 border-l-4 border-[#7C2D2D] pl-4" data-id="element-91">
              Clases que preparar. Contenidos que ordenar. Actividades que
              pensar. Evaluaciones que armar.
            </p>

            <p className="mb-4" data-id="element-92">
              Y muchas veces, todo eso fuera del horario escolar.
            </p>

            <p className="mb-8" data-id="element-93">
              No porque no sepas enseñar. No porque no tengas experiencia. Sino
              porque planificar bien lleva tiempo.
              <span className="font-bold text-[#7C2D2D]" data-id="element-94">
                {' '}
                Tiempo que casi nunca sobra.
              </span>
            </p>

            <h2 className="font-serif text-3xl font-bold text-[#2D241E] mt-12 mb-6 text-center" data-id="element-95">
              El verdadero problema no es dar clases
            </h2>

            <p className="text-center text-xl italic text-[#8B4513] mb-8" data-id="element-96">
              El problema es tener que organizarlo todo solo, cada año.
            </p>

            <ul className="space-y-4 mb-10 bg-[#F4E8D8] p-8 rounded-sm border border-[#8B4513]/30" data-id="element-97">
              <li className="flex items-start gap-3" data-id="element-98">
                <span className="text-[#7C2D2D] font-bold text-xl" data-id="element-99">✗</span>
                <span data-id="element-100">Buscar materiales.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-101">
                <span className="text-[#7C2D2D] font-bold text-xl" data-id="element-102">✗</span>
                <span data-id="element-103">Unir PDFs.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-104">
                <span className="text-[#7C2D2D] font-bold text-xl" data-id="element-105">✗</span>
                <span data-id="element-106">Adaptar textos.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-107">
                <span className="text-[#7C2D2D] font-bold text-xl" data-id="element-108">✗</span>
                <span data-id="element-109">Reescribir consignas.</span>
              </li>
            </ul>

            <p className="text-lg font-medium" data-id="element-110">
              Y aun así, entrar al aula con la sensación de que algo falta. No
              falta compromiso. No falta vocación.
            </p>

            <div className="mt-8 text-center" data-id="element-111">
              <span className="inline-block bg-[#2D241E] text-[#F4E8D8] px-6 py-2 font-serif font-bold text-xl rounded-sm transform -rotate-1" data-id="element-112">
                👉 Falta orden.
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-[#2D241E] text-[#F4E8D8] relative overflow-hidden" data-id="element-113">
        {/* Vintage map background effect */}
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/shattered-island.png')]" data-id="element-114"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-115">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8 text-[#F4E8D8]" data-id="element-116">
            ¿Y si ese trabajo ya estuviera hecho?
          </h2>

          <p className="text-xl mb-12 text-[#FFF8E7]/90 max-w-2xl mx-auto" data-id="element-117">
            Imaginá abrir un archivo y encontrar:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left" data-id="element-118">
            {['Los contenidos organizados por períodos históricos', 'Lecciones claras y coherentes', 'Actividades listas para usar', 'Líneas de tiempo y esquemas visuales', 'Propuestas de evaluación ya pensadas'].map((item, index) => <div key={index} className="bg-[#3E3228] p-6 rounded-sm border border-[#8B4513] hover:border-[#7C2D2D] transition-colors" data-id="element-119">
                <Check className="w-8 h-8 text-[#7C2D2D] mb-4" data-id="element-120" />
                <p className="font-serif text-lg" data-id="element-121">{item}</p>
              </div>)}
          </div>

          <div className="mt-16 bg-[#F4E8D8] text-[#2D241E] p-8 md:p-12 rounded-sm shadow-2xl border-4 border-[#7C2D2D] max-w-3xl mx-auto transform rotate-1" data-id="element-122">
            <p className="font-sans font-bold text-[#7C2D2D] tracking-widest uppercase mb-4 text-sm" data-id="element-123">
              TODO EN UN MISMO LUGAR
            </p>
            <h3 className="font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-124">
              PACK HISTORIA PARA DOCENTES
            </h3>
            <p className="font-serif text-xl md:text-2xl italic text-[#8B4513] mb-8" data-id="element-125">
              Nivel Secundario
            </p>
            <p className="font-sans text-lg mb-8" data-id="element-126">
              Un Pack Integral de Historia, creado para docentes que necesitan:
            </p>
            <div className="flex flex-wrap justify-center gap-4 font-bold text-[#5D4037]" data-id="element-127">
              <span className="flex items-center gap-2" data-id="element-128">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-129" /> Ahorrar tiempo real
              </span>
              <span className="flex items-center gap-2" data-id="element-130">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-131" /> Ordenar su
                planificación
              </span>
              <span className="flex items-center gap-2" data-id="element-132">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-133" /> Tener material
                listo
              </span>
              <span className="flex items-center gap-2" data-id="element-134">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-135" /> Enseñar con
                tranquilidad
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Product Details - Cuadernillos */}
      <section className="py-20 px-4 bg-[#F4E8D8]" data-id="element-136">
        <div className="max-w-5xl mx-auto" data-id="element-137">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-[#2D241E] mb-16" data-id="element-138">
            Este pack reúne cinco cuadernillos digitales,
            <br data-id="element-139" />
            <span className="text-[#7C2D2D]" data-id="element-140">
              organizados por grandes períodos históricos:
            </span>
          </h2>

          <div className="space-y-6" data-id="element-141">
            {[{
            title: 'Historia I',
            subtitle: 'Historia Antigua y Orígenes de la Humanidad'
          }, {
            title: 'Historia II',
            subtitle: 'Historia Medieval y Transición a la Modernidad'
          }, {
            title: 'Historia III',
            subtitle: 'Edad Moderna y Formación del Mundo Occidental'
          }, {
            title: 'Historia IV',
            subtitle: 'Historia Contemporánea – Siglos XIX y XX'
          }, {
            title: 'Historia V',
            subtitle: 'Historia Argentina y Latinoamericana'
          }].map((book, idx) => <div key={idx} className="flex items-center gap-6 bg-[#FFF8E7] p-6 rounded-sm border-l-8 border-[#7C2D2D] shadow-sm hover:shadow-md transition-shadow" data-id="element-142">
                <div className="bg-[#2D241E] text-[#F4E8D8] w-12 h-12 flex items-center justify-center rounded-full font-serif font-bold text-xl flex-shrink-0" data-id="element-143">
                  {idx + 1}
                </div>
                <div data-id="element-144">
                  <h3 className="font-serif font-bold text-xl text-[#7C2D2D]" data-id="element-145">
                    {book.title}
                  </h3>
                  <p className="font-sans text-[#5D4037] font-medium" data-id="element-146">
                    {book.subtitle}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-4 bg-[#FFF8E7] border-y border-[#8B4513]/20" data-id="element-147">
        <div className="max-w-4xl mx-auto text-center" data-id="element-148">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2D241E] mb-12" data-id="element-149">
            ¿Qué cambia cuando trabajás con este pack?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-150">
            <div className="bg-[#F4E8D8] p-6 rounded-sm border border-[#8B4513]/20" data-id="element-151">
              <Clock className="w-10 h-10 text-[#7C2D2D] mx-auto mb-4" data-id="element-152" />
              <h3 className="font-serif font-bold text-xl mb-2" data-id="element-153">
                Dejás de planificar desde cero
              </h3>
              <p className="text-[#5D4037]" data-id="element-154">
                Tu tiempo vale. Usalo para descansar o disfrutar, no para
                reinventar la rueda.
              </p>
            </div>
            <div className="bg-[#F4E8D8] p-6 rounded-sm border border-[#8B4513]/20" data-id="element-155">
              <ShieldCheck className="w-10 h-10 text-[#7C2D2D] mx-auto mb-4" data-id="element-156" />
              <h3 className="font-serif font-bold text-xl mb-2" data-id="element-157">
                Ganás seguridad al entrar al aula
              </h3>
              <p className="text-[#5D4037]" data-id="element-158">
                Sabés exactamente qué dar y cómo encararlo en cada clase.
              </p>
            </div>
            <div className="bg-[#F4E8D8] p-6 rounded-sm border border-[#8B4513]/20" data-id="element-159">
              <BookOpen className="w-10 h-10 text-[#7C2D2D] mx-auto mb-4" data-id="element-160" />
              <h3 className="font-serif font-bold text-xl mb-2" data-id="element-161">
                Reutilizás el material
              </h3>
              <p className="text-[#5D4037]" data-id="element-162">
                Una inversión única que te sirve año tras año.
              </p>
            </div>
            <div className="bg-[#F4E8D8] p-6 rounded-sm border border-[#8B4513]/20" data-id="element-163">
              <Star className="w-10 h-10 text-[#7C2D2D] mx-auto mb-4" data-id="element-164" />
              <h3 className="font-serif font-bold text-xl mb-2" data-id="element-165">
                Recuperás energía mental
              </h3>
              <p className="text-[#5D4037]" data-id="element-166">
                Menos estrés por la planificación significa más energía para la
                enseñanza.
              </p>
            </div>
          </div>

          <div className="bg-[#2D241E] text-[#F4E8D8] p-8 rounded-sm inline-block max-w-2xl" data-id="element-167">
            <p className="font-serif text-2xl italic mb-2" data-id="element-168">
              "No es magia. No es improvisación."
            </p>
            <p className="font-bold text-xl uppercase tracking-widest text-[#F4E8D8]" data-id="element-169">
              Es organización docente.
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-[#F4E8D8]" data-id="element-170">
        <div className="max-w-6xl mx-auto" data-id="element-171">
          <div className="text-center mb-16" data-id="element-172">
            <span className="bg-[#7C2D2D] text-[#F4E8D8] px-4 py-1 font-bold rounded-full text-sm uppercase tracking-wider mb-4 inline-block" data-id="element-173">
              Oferta Especial Limitada
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#2D241E] mb-6" data-id="element-174">
              Bonos Exclusivos
            </h2>
            <p className="font-sans text-xl text-[#5D4037]" data-id="element-175">
              Llevate todo esto{' '}
              <span className="font-bold text-[#7C2D2D] underline" data-id="element-176">GRATIS</span>{' '}
              con tu compra hoy
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-177">
            <BonusCard title="BONUS 1: Planificación Anual" image="https://cdn.magicpatterns.com/uploads/ipaQBoNwpaAfbXebzDY5yy/ChatGPT_Image_15_ene_2026,_16_35_47.png" description="Planificación Anual y Trimestral. Organización completa del año lectivo con articulación de contenidos." data-id="element-178" />
            <BonusCard title="BONUS 2: Banco de Actividades" image="https://cdn.magicpatterns.com/uploads/f4CsSGb5JbhoHRsAgFrs5U/ChatGPT_Image_15_ene_2026,_16_35_43.png" description="Actividades listas para usar. De inicio, desarrollo y cierre. Trabajos prácticos y evaluaciones." data-id="element-179" />
            <BonusCard title="BONUS 3: Esquemas Visuales" image="https://cdn.magicpatterns.com/uploads/v4yB7c3L71YPc8fiXkqCMF/ChatGPT_Image_15_ene_2026,_16_35_37.png" description="Líneas de tiempo, cuadros comparativos y mapas conceptuales listos para imprimir o proyectar." data-id="element-180" />
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="purchase-section" className="py-24 px-4 bg-[#2D241E] text-[#F4E8D8] relative" data-id="element-181">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]" data-id="element-182"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-183">
          <div className="bg-[#F4E8D8] text-[#2D241E] p-8 md:p-12 rounded-lg shadow-2xl border-8 border-[#7C2D2D] max-w-2xl mx-auto" data-id="element-184">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-2" data-id="element-185">
              Pack Integral de Historia
            </h2>
            <p className="font-sans text-[#8B4513] font-medium mb-8 uppercase tracking-widest" data-id="element-186">
              Nivel Secundario + 3 Bonos Gratis
            </p>

            <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-187">
              <span className="text-2xl text-[#5D4037] line-through opacity-60" data-id="element-188">
                $35.000
              </span>
              <span className="text-6xl font-bold text-[#7C2D2D] font-serif" data-id="element-189">
                $19.990
              </span>
            </div>

            <div className="space-y-4 mb-8 text-left max-w-xs mx-auto text-[#5D4037]" data-id="element-190">
              <div className="flex items-center gap-3" data-id="element-191">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-192" />
                <span data-id="element-193">5 Cuadernillos de Historia</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-194">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-195" />
                <span data-id="element-196">3 Bonos Exclusivos</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-197">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-198" />
                <span data-id="element-199">Acceso Inmediato (PDF)</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-200">
                <Check className="w-5 h-5 text-[#7C2D2D]" data-id="element-201" />
                <span data-id="element-202">Pago Único</span>
              </div>
            </div>

            <a href="https://checkout4.rosetadigital.com/cart/42922343399485:1" className="block w-full bg-[#7C2D2D] hover:bg-[#5D2020] text-[#F4E8D8] text-xl md:text-2xl font-bold py-4 px-8 rounded-sm shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4 border-2 border-[#8B4513]" data-id="element-203">
              DESCARGAR AHORA EL PACK INTEGRAL
            </a>

            <div className="flex justify-center items-center gap-2 text-sm text-[#5D4037]" data-id="element-204">
              <ShieldCheck className="w-4 h-4" data-id="element-205" />
              <span data-id="element-206">Compra 100% Segura y Garantizada</span>
            </div>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 text-center text-[#F4E8D8]/80 text-sm font-sans" data-id="element-207">
            <div className="flex flex-col items-center" data-id="element-208">
              <div className="bg-[#3E3228] p-3 rounded-full mb-3 border border-[#8B4513]" data-id="element-209">
                <Download className="w-6 h-6" data-id="element-210" />
              </div>
              <p data-id="element-211">Material 100% digital (PDF)</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-212">
              <div className="bg-[#3E3228] p-3 rounded-full mb-3 border border-[#8B4513]" data-id="element-213">
                <Clock className="w-6 h-6" data-id="element-214" />
              </div>
              <p data-id="element-215">Descarga inmediata</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-216">
              <div className="bg-[#3E3228] p-3 rounded-full mb-3 border border-[#8B4513]" data-id="element-217">
                <BookOpen className="w-6 h-6" data-id="element-218" />
              </div>
              <p data-id="element-219">Apto para imprimir</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 bg-[#FFF8E7]" data-id="element-220">
        <div className="max-w-6xl mx-auto" data-id="element-221">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-[#2D241E] mb-16" data-id="element-222">
            Docentes de todo el país{' '}
            <span className="text-[#7C2D2D]" data-id="element-223">ya están usando el pack</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-224">
            <TestimonialCard name="Claudia Morales" age="42 años" role="Profesora de Historia" location="Buenos Aires" content="Antes pasaba los fines de semana buscando material. Ahora tengo todo organizado y puedo dedicarme a corregir tranquila. Mis alumnos notaron el cambio en la organización de las clases." data-id="element-225" />
            <TestimonialCard name="Javier Peralta" age="38 años" role="Docente de Secundaria" location="Córdoba" content="Lo que más valoro es la coherencia de los cuadernillos. No es un rejunte de cosas, hay una línea pedagógica clara. Los bonos de planificación me salvaron el inicio de clases." data-id="element-226" />
            <TestimonialCard name="Silvina Romero" age="45 años" role="Profesora de Historia" location="Rosario" content="Tengo 6 cursos diferentes y me estaba volviendo loca. Este pack me dio el orden que necesitaba. Las actividades son muy buenas y adaptables a distintos grupos." data-id="element-227" />
            <TestimonialCard name="Martín Acosta" age="51 años" role="Docente con 20 años de exp." location="Mendoza" content="Incluso con años de experiencia, a veces te quedás sin ideas nuevas. Este material me renovó las ganas de dar ciertos temas. Las líneas de tiempo son excelentes." data-id="element-228" />
            <TestimonialCard name="Patricia Vega" age="36 años" role="Profesora de Historia" location="La Plata" content="La mejor inversión que hice este año. Recuperé mis domingos. El material es súper completo y visualmente atractivo para los chicos. ¡Recomendadísimo!" data-id="element-229" />
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 px-4 bg-[#F4E8D8] border-t border-[#8B4513]/20" data-id="element-230">
        <div className="max-w-3xl mx-auto text-center" data-id="element-231">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2D241E] mb-6" data-id="element-232">
            Una decisión que se agradece con el tiempo
          </h2>
          <p className="font-sans text-xl text-[#5D4037] mb-8" data-id="element-233">
            Hay decisiones que se notan en el momento. Y otras que se agradecen
            durante todo el año.
            <br data-id="element-234" />
            <span className="font-bold italic" data-id="element-235">Esta es una de esas.</span>
          </p>

          <div className="bg-[#FFF8E7] p-6 rounded-sm border-l-4 border-[#7C2D2D] mb-10 text-left mx-auto max-w-xl shadow-sm" data-id="element-236">
            <p className="font-serif text-lg text-[#2D241E]" data-id="element-237">
              Invertís una vez. Lo usás durante años.
            </p>
          </div>

          <button onClick={scrollToPurchase} className="bg-[#7C2D2D] hover:bg-[#5D2020] text-[#F4E8D8] text-xl font-bold py-4 px-10 rounded-sm shadow-lg hover:shadow-xl transition-all border-2 border-[#8B4513]" data-id="element-238">
            DESCARGAR AHORA EL PACK
          </button>

          <p className="mt-6 text-sm text-[#8B4513] opacity-80" data-id="element-239">
            Sin envíos. Sin esperas. Sin vueltas.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#2D241E] text-[#F4E8D8]/60 py-12 px-4 text-center font-sans text-sm" data-id="element-240">
        <div className="max-w-4xl mx-auto" data-id="element-241">
          <div className="flex justify-center items-center gap-2 mb-6 opacity-80" data-id="element-242">
            <BookOpen className="w-6 h-6" data-id="element-243" />
            <span className="font-serif font-bold text-lg tracking-wider text-[#F4E8D8]" data-id="element-244">
              HISTORIA DOCENTE
            </span>
          </div>
          <p className="mb-4" data-id="element-245">
            Material didáctico profesional para docentes de nivel secundario.
          </p>
          <p data-id="element-246">
            &copy; {new Date().getFullYear()} Pack Historia Integral. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}